// extracted by mini-css-extract-plugin
var _1 = "AccountSettings_action__gqQWI";
var _2 = "AccountSettings_actionsWrapper__NO3Av";
export { _1 as "action", _2 as "actionsWrapper" }
